import {
  OpportunityCard,
  GenericOpportunityCardContent,
} from '../components/OpportunityCard';
import { MailPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSelector } from 'react-redux';
import { selectClients, selectClientsIsLoading } from '@/model/selectors';

const PRIORITY_STATUS = 'Highly recommended';

type OpportunityClientCTAProps = {
  setShowInviteClientModal: (open: boolean) => void;
};

export function OpportunityClientCTA({
  setShowInviteClientModal,
}: OpportunityClientCTAProps) {
  const clients = useSelector(selectClients);
  const clientsIsLoading = useSelector(selectClientsIsLoading);

  if (clients.length !== 0) return null;

  return (
    <OpportunityCard
      priorityStatus={PRIORITY_STATUS}
      isLoading={clientsIsLoading}
      cardContent={
        <GenericOpportunityCardContent
          icon={
            <MailPlus
              className="h-8 w-8"
              strokeWidth={1}
            />
          }
          title={'Invite your First Client'}
          subtitle="Invite your first client via link or email."
        />
      }
      cardFooterContent={
        <Button
          className={'rounded-full'}
          onClick={() => {
            setShowInviteClientModal(true);
          }}
        >
          Get started
        </Button>
      }
    />
  );
}
